import { useMutation } from '@tanstack/react-query';
import { routes } from '../constants';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from 'store';
import { createManagementClientChannel } from 'api';
import { useToast } from 'hooks';

function useChat() {
  // Store
  const { isAuthenticated, user, clientId, setMgmChannelId, mgmChannelId } =
    useUserStore();

  // Hooks
  const navigate = useNavigate();
  const { toastError } = useToast();

  // Mutation
  const { mutateAsync: createMutate, isPending } = useMutation({
    mutationFn: () => {
      return createManagementClientChannel(clientId || '', false);
    },
    onSuccess(res) {
      if (res) {
        setMgmChannelId(res.id);
      }
    },
    onError(err) {
      toastError(err);
    },
    retry: 0,
  });

  const handleChatWithAdmin = useCallback(async () => {
    if (isPending) return;
    let channelId: string | undefined;
    if (isAuthenticated) {
      channelId = user?.managementChannelId;
    } else {
      try {
        channelId = mgmChannelId || (await createMutate())?.id;
      } catch (error) {}
    }

    if (channelId) {
      navigate(routes.CONVERSATION.replace(':id', channelId));
    }
  }, [
    isPending,
    isAuthenticated,
    createMutate,
    mgmChannelId,
    navigate,
    user?.managementChannelId,
  ]);

  return { handleChatWithAdmin };
}

export default useChat;
